import axios, { AxiosResponse } from "axios";
import i18n from "../../i18n";
import apiClient from "./apiClient";
import Cookies from "js-cookie";
import { AuthResponse } from "../../shared/models/AuthResponse";

export const getTradePointById = async (id: number): Promise<any> => {
    const token = Cookies.get('access_token');
    try {
      const response: AxiosResponse<any> = await axios.get(
        `https://order.articool.online/orders/trade-points/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error(`Ошибка при получении торговой точки с ID ${id}:`, error);
      throw error;
    }
  };

  interface TradePointUpdatePayload {
    name: string;
    bin: string;
    address: string;
    phone: string;
    email: string;
    disabled: boolean;
  }
  
  export const updateTradePoint = async (
    id: number,
    data: TradePointUpdatePayload
  ): Promise<any> => {
    const token = Cookies.get('access_token');
    try {
      const response: AxiosResponse<any> = await axios.put(
        `https://order.articool.online/orders/trade-points/${id}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error(`Ошибка при обновлении торговой точки с ID ${id}:`, error);
      throw error;
    }
  };

  export const getAllTradePoints = async (): Promise<any[]> => {
    const token = Cookies.get('access_token');
    try {
      const response: AxiosResponse<any[]> = await axios.get(
        "https://order.articool.online/trade-points",
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Ошибка при получении списка торговых точек:", error);
      throw error;
    }
  };

  interface TradePointCreatePayload {
    name: string;
    bin: string;
    address: string;
    phone: string;
    email: string;
    disabled: boolean;
    role: string;
  }

  export interface TradePointRequest {
    name: string;
    bin: string;
    address: string;
    phone: string;
    email: string;
    disabled: boolean;
    role: string;
  }
  
  export const createTradePoint = async (
    data: TradePointCreatePayload
  ): Promise<any> => {
    const token = Cookies.get('access_token');
    try {
        const token = Cookies.get("access_token");
        const response: AxiosResponse<any> = await apiClient.post(
            `https://order.articool.online/orders/trade-points`,
            data,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Ошибка при создании торговой точки:", error);
        throw error;
    }
};

interface TradePoint {
    id: number;
    name: string;
    bin: string;
    address: string;
    phone: string;
    email: string;
    createdAt: string;
    updatedAt: string;
}

interface TradePointListResponse {
    totalItems: number;
    itemsPerPage: number;
    totalPages: number;
    currentPage: number;
    tradePoints: TradePoint[];
}

export const getTradePointList = async (page = 1, size = 1000): Promise<TradePointListResponse> => {
    try {
        const token = Cookies.get("access_token");
        const response: AxiosResponse<TradePointListResponse> = await apiClient.get(
            `https://order.articool.online/orders/trade-points`,
            {
                params: { page, size },
                headers: {
                    "Authorization": `Bearer ${token}`,
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("Ошибка при получении списка торговых точек:", error);
        throw error;
    }
};

// export const updateTradePoint = async (tradePointId: number, data: TradePointRequest): Promise<any> => {
//     try {
//         const token = Cookies.get("access_token");
//         const response: AxiosResponse<any> = await apiClient.put(
//             `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/trade-point/${tradePointId}`,
//             data,
//             {
//                 headers: {
//                     "Content-Type": "application/json",
//                     "Authorization": `Bearer ${token}`,
//                 },
//             }
//         );
//         return response.data;
//     } catch (error) {
//         console.error("Ошибка при обновлении данных торговой точки:", error);
//         throw error;
//     }
// };

export const deleteTradePoint = async (tradePointId: number): Promise<any> => {
    try {
        const token = Cookies.get("access_token");
        const response: AxiosResponse<any> = await apiClient.delete(
            `https://order.articool.online/orders/trade-points/${tradePointId}`,
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Ошибка при удалении торговой точки:", error);
        throw error;
    }
};

  interface InviteEmployeePayload {
    email: string;
    employeeName: string;
  }
  
  export const inviteEmployeeToTradePoint = async (
    tradePointId: string,
    data: InviteEmployeePayload
  ): Promise<any> => {
    const token = Cookies.get('access_token');
    try {
      const response: AxiosResponse<any> = await axios.post(
        `https://order.articool.online/orders/trade-points/${tradePointId}/invite`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error(`Ошибка при приглашении сотрудника в точку ${tradePointId}:`, error);
      throw error;
    }
  };

  export const acceptEmployeeInvitation = async (
    tokenParam: string
  ): Promise<any> => {
    const token = Cookies.get('access_token');
    try {
      const response: AxiosResponse<any> = await axios.post(
        `https://order.articool.online/orders/trade-points/invitations/accept/${tokenParam}`,
        {}, // тело запроса пустое
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error(`Ошибка при подтверждении приглашения с токеном ${tokenParam}:`, error);
      throw error;
    }
  };

